import { useTranslation } from '../../utils/convergence'

import React, { useEffect, useState } from 'react'
import { Head } from '../../component'
import { Button } from '@afterpaytouch/core'

import { TrackPageViewed } from '../../integrations/monitoring'
import { CheckoutPage, TrackingEvent } from '../../model'
import { setHasSeenEducationIntro, useAppDispatch, useAppRouter, useIntegrationNextRoute, useIsAppleRetailOrder } from '../../state'
import { Route } from '../../config/router'
import { UniqueSellingPoint, HeroImage, NewToAfterpay, Terms, Divider } from './components'
import { useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'

export const EducationIntroPage: CheckoutPage = () => {
  const { t } = useTranslation()
  const router = useAppRouter()
  const dispatch = useAppDispatch()
  const [loading, setLoading] = useState(false)
  const pageTitle = `${t('common:brandName')}`
  const isAppleRetailOrder = useIsAppleRetailOrder()
  const nextRoute = useIntegrationNextRoute()
  const { logEvent } = useMonitoringWithEnduringEventProperties()

  const handleContinue = () => {
    setLoading(true)
    logEvent(TrackingEvent.PRESSED_CONTINUE_BUTTON_ON_EDUCATION_INTRO_PAGE)
    router.replace(nextRoute)
  }

  useEffect(() => {
    if (!isAppleRetailOrder) {
      router.replace(nextRoute ?? Route.ENTER_EMAIL)
      return
    }
    dispatch(setHasSeenEducationIntro(true))
  }, [])

  if (!isAppleRetailOrder) {
    return null
  }

  return (
    <>
      <Head title={pageTitle} />
      <HeroImage />
      <UniqueSellingPoint />
      <NewToAfterpay />
      <Divider />
      <Terms />
      <Button loading={loading} onClick={handleContinue} testNameSpace='education-intro'>
        {t('educationIntro:continue')}
      </Button>
      <TrackPageViewed />
    </>
  )
}
